/**
 * Binary search algorithm that finds a index of a value closest to `value`
 * in a sorted array `range`.
 * @param value Value we are looking for
 * @param range Sorted array
 */
export const findClosestValue = (
  value: number | undefined | null,
  range: number[]
): number | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }

  let left = 0;
  let right = range.length - 1;

  while (right - left > 1) {
    const middle = left + Math.floor((right - left) / 2);
    const middleValue = range[middle];
    if (middleValue > value) {
      right = middle;
    } else if (middleValue < value) {
      left = middle;
    } else {
      return middle;
    }
  }

  if (Math.abs(value - range[left]) <= Math.abs(value - range[right])) {
    return left;
  } else {
    return right;
  }
};
